<ngb-alert
  class="alert-info"
  [type]="'info'"
  [hidden]="!show"
  (closed)="hide()"
>
  Sorry, you don't have access to this project. Contact an account admin for
  access.
</ngb-alert>
